/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Modal_Confirmbutton3Inputs */

const en_coinvestments_closedeal_modal_confirmbutton3 = /** @type {(inputs: Coinvestments_Closedeal_Modal_Confirmbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close deal`)
};

/**
* | output |
* | --- |
* | "Close deal" |
*
* @param {Coinvestments_Closedeal_Modal_Confirmbutton3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_modal_confirmbutton3 = /** @type {((inputs?: Coinvestments_Closedeal_Modal_Confirmbutton3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Modal_Confirmbutton3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_modal_confirmbutton3(inputs)
});
export { coinvestments_closedeal_modal_confirmbutton3 as "coInvestments_closeDeal_modal_confirmButton" }